export default {
  /** 产品入库-获取分页查询列表 */
  LIST_INSTOCK_BY_PAGE: '/produce/pdProductInboundDetail/queryPage',
  /** 产品入库-批量导入 */
  LIST_INSTOCK_IMPORT: '/produce/pdProductInboundDetail/importExcel',
  /** 产品入库-批量导出 */
  LIST_INSTOCK_EXPORT: '/produce/pdProductInboundDetail/exportExcel',
  /** 产品入库-批量删除 */
  LIST_INSTOCK_DELETE: '/produce/pdProductInboundDetail/deleteByIds',
};
